import styled, {keyframes} from 'styled-components';

interface Props {
  pattern?: string;
}

const sideUpScroll = keyframes`
    0% {
        transform: translate3d(0%, 0%, 1px);
    }
    50% {
        transform: translate3d(-50%, -50%, 1px);
    }
    100% {
        transform: translate3d(0%, 0%, 1px);
    }
`;

const CrewPattern = styled.div<Props>`
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  height: 400%;
  background: ${(props) => (props.pattern ? `url(${props.pattern}) repeat` : 'none')};
  background-position: 0 0;
  background-size: 250px auto;
  z-index: 100;
  animation: ${sideUpScroll} 100s linear infinite both;
`;

export default CrewPattern;
